export const title = 'BREEZE Software Key Generation Request Form';
export const blurb =
  'Please select your product carefully. Choosing the wrong product will result in a delay in providing you the correct key.';
export const link = 'Submit Request';
export const checkbox_title = 'Do you have a BREEZE Customer Site ID?';
